export const PAGINATION_INITIAL_STATE = {
  page: null,
  next_page: null,
  prev_page: null,
  total_pages: null,
  total_results: null
}
